import React, { Component } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';

import CustomModal from "../../components/Modal/CustomModal";

import { Row, Col, Table, Popover, OverlayTrigger, Panel, PanelGroup } from "react-bootstrap";
import { CustomCard } from "../../components/Card/CustomCard";

import { consultCarreras } from '../../funciones/MateriasFunction';
import { CarreraActual, consultaSolicitudes, SolicitarNotasCert } from '../../funciones/NotasCertificadasFunction';
import { consultaEst } from "../../funciones/CambioCarrFunction";
import { ConsultaAcademicosEst } from '../../funciones/RendAcadFunction';

import MensajeRetraso from "../../shared/MensajeRetraso";
import { ConsultaDeuda } from '../../funciones/EstCuentaFunction';
import { InfoUC } from '../../funciones/InscripcionFunction';
import { Precios } from '../../funciones/AdministracionFunction';
import { formatNumber, formatReconver } from "../../funciones/GeneralFunctions";

let statusBtn = 0;
let deudaTSolic = "";
let statusEst= 0;

class NotasCertificadas extends Component {
    state = {
        valorCarrera: { value: '', label: '- Selecciona una Carrera -' },
        carreras: [{ value: '', label: ' - Cargando Espere - ', num: '' }],
        materiasHistorico: [],
        boton: {
            icon: "fa fa-file",
            text: "Solicitar Notas Certificadas"
        },
        botonSimple: {
            icon: "fa fa-file-o",
            text: "Solicitar Notas Simples"
        },
        solicitudesC: [],
        openW: false,
        openWs: false,
        boton2: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },

        carrerasHist: [],
        materias: [],
        materiashHist: [],
        semestres: [],
        textCarreras: <React.Fragment><i className ="fa fa-spinner fa-spin"></i> Buscando las carreras, espera</React.Fragment>,
        iconChevron: "fa fa-chevron-down",
        btnDown: true,
        ValorUc: "",
        valorCambioCarr: {
            uc: "",
            bs: ""
        }
    }

    constructor (props) {
        super (props);

        consultCarreras ((resp) => {
            this.setState({
                carreras: resp
            }, () => {
                CarreraActual ((resp2) => {
                    this.setState({
                        valorCarrera: resp2,
                        openW: false,
                    })
                })
            })
        })

        consultaSolicitudes ((resp) => {
            statusBtn = resp[1]
            this.setState({
                solicitudesC: resp[0],
                openW: false,
            })
        })

        consultaEst((resp) => {
            statusEst = resp[1];
            ConsultaAcademicosEst(resp[0].id, (respData) => {
                this.setState({
                    carrerasHist: respData[0],
                    materiashHist: respData[1],
                    semestres: respData[2],
                })
            })
        })

        InfoUC ((resp) => {
            this.setState({ValorUc: resp})
        })

        Precios("NOTAS CERTIFICADAS", (resp) => {
            this.setState({valorCambioCarr: resp})
        })
    }

    componentDidMount = () => {
        ConsultaDeuda ((resp) => {
            deudaTSolic = resp.deudaVencida
            this.setState({deudaT: resp.deudaVencida})
        })
    }

    valorCarrera = (valorCarrera) => { this.setState({
        valorCarrera,
        openW: false,
    }) }

    solicitaNotas = (tipo) => (e) => {
        if (this.state.boton2.disabled === true) return null;

        this.setState({
            boton2: {
                icon: "fa fa-spin fa-spinner",
                text: "Espera",
                disabled: true
            },
        }, () => {
            SolicitarNotasCert (this.state.valorCarrera.value, tipo, (resp) => {
                if(resp.status === "error") {
                    toast.error("No posees materias registradas en la carrera seleccionada",{autoClose: 4000});
                    this.setState({
                        boton2: {
                            icon: "fa fa-check",
                            text: "Si",
                            disabled: false
                        },
                    })
                }else if(resp.status === "ok") {
                    toast.info("Solicitud de Notas completada. Puedes revisar el status de esta solicitud desde este módulo",{autoClose: 4000});
                    consultaSolicitudes ((resp) => {
                        statusBtn = resp[1]
                        this.setState({
                            openWs: false,
                            boton2: {
                                icon: "fa fa-check",
                                text: "Si",
                                disabled: false
                            },
                            solicitudesC: resp[0],
                        })
                    })
                }
                this.setState({
                    openW: false
                })
            })
        })
    }

    showModal = () => {
        let { boton2, valorCambioCarr } = this.state;
        let contenidoModal = () => (
            <React.Fragment>
                <div>¿Deseas solicitar <strong className="text-primary">Notas Certificadas</strong> para la carrera <strong>{this.state.valorCarrera.label}</strong>?</div>
                <div style={{fontSize:10}}>Esta opción no puede deshacerse y no podrás solicitar otra hasta que esta sea respondida</div>
                <div style={{fontSize:12}}>Este trámite tiene un costo de <strong className="text-danger">{valorCambioCarr.uc} U.C.</strong> o <strong className="text-danger">{formatNumber(valorCambioCarr.bs)} Bs.{/*  | {formatReconver(valorCambioCarr.bs)} Bs. */}</strong> y se añadirá  automáticamente a tu estado de cuenta</div>
            </React.Fragment>
        )
        return (
            <CustomModal
                isopen =  {this.state.openW}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal()}
                boton1 = {<React.Fragment><i className= {boton2.icon}></i> {boton2.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className= "fa fa-times"></i> No</React.Fragment>}
                funcion1 = {this.solicitaNotas("certificadas")}
                funcion2 = {() => {this.setState({openW: false})}}/>
        );
    }

    showModalS = () => {
        let { boton2, valorCambioCarr } = this.state;
        let contenidoModal = () => (
            <React.Fragment>
                <div>¿Deseas solicitar <strong className="text-primary">Notas Simples</strong> para la carrera <strong>{this.state.valorCarrera.label}</strong>?</div>
                <div style={{fontSize:10}}>Esta opción no puede deshacerse y no podrás solicitar otra hasta que esta sea respondida</div>
                <div style={{fontSize:12}}>Este trámite tiene un costo de <strong className="text-danger">{valorCambioCarr.uc} U.C.</strong> o <strong className="text-danger">{formatNumber(valorCambioCarr.bs)} Bs.{/*  | {formatReconver(valorCambioCarr.bs)} Bs. */}</strong> y se añadirá  automáticamente a tu estado de cuenta</div>
            </React.Fragment>
        )
        return (
            <CustomModal
                isopen =  {this.state.openWs}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal()}
                boton1 = {<React.Fragment><i className= {boton2.icon}></i> {boton2.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className= "fa fa-times"></i> No</React.Fragment>}
                funcion1 = {this.solicitaNotas("simples")}
                funcion2 = {() => {this.setState({openWs: false})}}/>
        );
    }

    abrirModal = () => (e) => {
        this.setState({
            openW: true,
            openWs: false,
        })
    }

    abrirModalS = () => (e) => {
        this.setState({
            openW: false,
            openWs: true,
        })
    }

    botones = () => {
        let { boton, botonSimple } = this.state;
        if (deudaTSolic === "") return (
            <Col md ={12} className="custom-mt-10">
                <div className="text-danger" align = "center"><i className="fa fa-spinner fa-spin"></i> Buscando Información, espera</div>
            </Col>
        )

        if (deudaTSolic > 0) return null;

        switch (statusBtn) {
            case 0:
                return (
                    <button className="btn btn-primary" style={{borderWidth: 1}}><i className="fa fa-spin fa-spinner"></i> Cargando</button>
                );
            case 1:
                if (statusEst === 6) {
                    let contenido6 = (
                        <Popover bsSize="large" id="sincuenta">
                            <div className="custom-alert-danger" align="center">No puedes realizar este proceso</div>
                            <div align="justify" className="custom-mt-10">
                                No puedes realizar este proceso porque no tienes Estado de Cuenta
                            </div>
                        </Popover>
                    )
    
                    return (
                        <div className="btn-group" role="group">
                            <OverlayTrigger trigger="focus" placement="left" overlay={contenido6}>
                                <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton.icon}></i> {boton.text}</button>
                            </OverlayTrigger>
                            <OverlayTrigger trigger="focus" placement="right" overlay={contenido6}>
                                <button style={{borderWidth: 1}} className="btn btn-warning"><i className={botonSimple.icon}></i> {botonSimple.text}</button>
                            </OverlayTrigger>
                        </div>
                    )
                }

                return (
                    <div className="btn-group">
                        <button className="btn btn-primary" onClick = {this.abrirModal()} style={{borderWidth: 1}}><i className={boton.icon}></i> {boton.text}</button>
                        <button className="btn btn-warning" onClick = {this.abrirModalS()} style={{borderWidth: 1}}><i className={botonSimple.icon}></i> {botonSimple.text}</button>
                    </div>
                )
            case 2:
                let contenido = (
                    <Popover bsSize="large" title="Importante" id="Inscrito">
                        <div className="custom-alert-danger" align="center">Tienes solicitudes abiertas</div>
                        <div align="justify" className="custom-mt-10">
                            Ya has hecho una petición de Notas, espera que su Status cambie para poder realizar una nueva petición
                        </div>
                    </Popover>
                )

                return (
                    <div className="btn-group" role="group">
                        <OverlayTrigger trigger="focus" placement="left" overlay={contenido}>
                            <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton.icon}></i> {boton.text}</button>
                        </OverlayTrigger>
                        <OverlayTrigger trigger="focus" placement="right" overlay={contenido}>
                            <button style={{borderWidth: 1}} className="btn btn-warning"><i className={botonSimple.icon}></i> {botonSimple.text}</button>
                        </OverlayTrigger>
                    </div>
                )
            default:
                return (
                    <button className="btn btn-primary" style={{borderWidth: 1}}><i className="fa fa-times"></i> Error</button>
                )
        }
    }

    cambiaIcon = () => {
        this.setState ({
            btnDown: !this.state.btnDown,
        }, () => {
            (this.state.btnDown === true) ? this.setState({iconChevron: "fa fa-chevron-down"}) : this.setState({iconChevron: "fa fa-chevron-up"})
        })
    }

    carreras = () => {
        if (deudaTSolic === "") return (
            <Col md ={12} className="custom-mt-10">
                <div className="text-danger" align = "center"><i className="fa fa-spinner fa-spin"></i> Buscando Información, espera</div>
            </Col>
        )

        if (deudaTSolic > 0) return (<MensajeRetraso />)

        let { carrerasHist, textCarreras, iconChevron } = this.state;
        const styles = {
            padding: 5, fontSize: 10
        }

        if (carrerasHist.length === 0) return (
            <div align="center" className="custom-color custom-mt-10">{textCarreras}</div>
        )

        let materias = (idCarrera) => {
            let { materiashHist, semestres } = this.state;
            let SemContent = [];

            let enLetras= (nota) => {
                let letras = [
                    "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ",
                    "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO",
                    "DIECINUEVE", "VEINTE"
                ];

                return letras[nota - 1]
            }

            let mes = (num) => {
                let meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
                
                return meses[num - 1]
            }

            let nota = (nota, tipo) => {
                if (tipo === 1) return (
                    <React.Fragment>
                        <td align="center" style={styles}>{nota}</td>
                        <td align="center" style={styles}>{enLetras(nota)}</td>
                    </React.Fragment>
                )

                if (nota === "" || nota === "0") return (
                    <td align="center" colSpan={2} style={styles}></td>
                )

                return (
                    <td align="center" colSpan= {2} style={styles}>{literal(nota)}</td>
                )
            }

            let literal = (nota) => {
                if (nota === "1") return "APROBADO";
                return "REPROBADO"
            }

            let materiasSem = (sem) => {
                let materiasContent = [];

                for (let i in materiashHist) {
                    if (idCarrera === materiashHist[i].carrera_id && sem === materiashHist[i].semestre_num) materiasContent.push (
                        <tr key={materiashHist[i].id}>
                            <td align="center" style={{padding: 5, fontSize: 8}}>{materiashHist[i].codigo}</td>
                            <td style={styles}>{materiashHist[i].materia_name}</td>
                            <td align="center" style={styles}>{`${mes(materiashHist[i].corte_name)} ${materiashHist[i].corte_year}`}</td>
                            <td align="center" style={styles}>{materiashHist[i].tipoev_name}</td>
                            {nota(materiashHist[i].nota, materiashHist[i].cuantitativo)}
                        </tr>
                    )
                }

                return materiasContent;
            }

            for (let i in semestres) {
                if (idCarrera === semestres[i].carrera_id) SemContent.push (
                    <div key={i} className="custom-sem-historico">
                        <div style={{padding: 5}}>
                            <Row>
                                <Col md={12} style={{paddingTop:10, paddingLeft: 20}}>
                                    <strong style={{marginTop:5}} className="text-danger">{semestres[i].semestre_name}</strong>
                                </Col>
                            </Row>
                        </div>
                        <div className="custom-mt-10">
                            <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                                <Table striped hover bordered>
                                    <tbody>
                                        <tr className="custon-back-color">
                                            <td align="center" width="10%" style={styles}><strong>CÓDIGO</strong></td>
                                            <td width="45%" style={styles}><strong>MATERIA</strong></td>
                                            <td align="center" width="10%" style={styles}><strong>PERIODO</strong></td>
                                            <td align="center" width="10%" style={styles}><strong>T-E</strong></td>
                                            <td align="center" width="10%" style={styles}><strong>NOTA</strong></td>
                                            <td align="center" width="15%" style={styles}><strong>LETRAS</strong></td>
                                        </tr>
                                        {materiasSem(semestres[i].semestre_num)}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                )
            }

            if (semestres.length === 0) return (<div align="center">No existen periodos registrados en esta carrera</div>)

            return SemContent;
        }

        let carrerasList = () => (
            carrerasHist.map(option => (
                <Panel eventKey={option.id} key ={option.id} style={{marginBottom:5, marginTop: 5}}>
                    <Panel.Heading>
                        <Panel.Title toggle className="custom-color" onClick={this.cambiaIcon}>
                            <Row>
                                <Col md={10} style={{fontSize: 12}}>
                                    <strong>{option.carrera_name}</strong>
                                    <spam style={{fontSize: 10}}> (Haz click aqui para ver)</spam>
                                </Col>
                                <Col md={2} align="right">
                                    <i className={iconChevron}></i>
                                </Col>
                            </Row>
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                        {materias(option.id)}
                    </Panel.Body>
                </Panel>
            ))
        )

        return (
            <PanelGroup accordion activeKey={this.state.activeKey} className="custom-alert-info" id="semestres">
                {carrerasList()}
            </PanelGroup>
        )
    }

    contenido = () => {
        let { valorCarrera, carreras, solicitudesC, ValorUc, valorCambioCarr } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let status = (status) => {
            switch (parseInt(status)) {
                case 0:
                    return <div className="text-warning"><i className="fa fa-money"></i> PAGO PENDIENTE </div>;
                case 1:
                    return <div className="text-warning"><i className="fa fa-exclamation-circle"></i> PENDIENTE POR CONTROL DE ESTUDIOS</div>;
                case 2:
                    return <div className="text-success"><i className="fa fa-check-circle"></i> APROBADA</div>;
                case 3:
                    return <div className="text-danger"><i className="fa fa-times-circle"></i> NO APROBADA</div>;
                default:
                    return 'PENDIENTE';
            }
        }

        let tipoSolicitud = (tipo, carrera) => {
            if(tipo === 1) return `NOTAS CERTIFICADAS - [${carrera}]`;
            return `NOTAS SIMPLES - [${carrera}]`;
        }

        let solicitudes = () => {
            if (solicitudesC.length === 0) {
                return (
                    <tr>
                        <td width="100%" colSpan={6} style={styles} align="center">No posees ninguna solicitud de Notas</td>
                    </tr>
                )
            }else{
                return (
                    solicitudesC.map(option => (
                        <tr key={option.id}>
                            <td style={styles}>{tipoSolicitud(option.certificada, option.carrera_name)}</td>
                            <td align="center" style={styles}>{option.fecha}</td>
                            <td align="center" style={styles}>{status(option.status)}</td>
                        </tr>
                    ))
                )
            }
        }

        let facturacion = () => (
            <Col md={12}>
                <div className="custom-mt-10 text-danger" align="right">
                    Valor actual de la Unidad de Crédito: <span className="badge badge-red">{formatNumber(ValorUc)} Bs.{/*  | {formatReconver(ValorUc)} Bs. */}</span>
                </div>
                <div align="right">
                    Este trámite tiene un costo de <strong>{valorCambioCarr.uc} U.C.</strong> o <strong>{formatNumber(valorCambioCarr.bs)} Bs.{/*  | {formatReconver(valorCambioCarr.bs)} Bs. */}</strong>
                </div>
            </Col>
        )


        return (
            <React.Fragment>
                <div className="custom-alert-info" style={{padding: 5}}>
                    <Row>
                        <Col md={6} style={{paddingTop: 10}}>Selecciona la Carrera</Col>
                        <Col md={6}>
                            <Select
                                isSearchable ={true}
                                value={valorCarrera}
                                onChange={this.valorCarrera}
                                options={carreras}
                            />
                        </Col>
                    </Row>
                </div>
                <Row>
                    <Col md={12}>{facturacion()}</Col>
                </Row>
                <Row>
                    <Col md={12} className="custom-mt-10" align="right">
                        {this.botones()}
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        <div className="custom-alert-info">Histórico de Solicitudes Realizadas</div>
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        <div className="table-responsive" style={{maxHeight:"40vh", overflowY: "auto"}}>
                            <Table striped hover bordered>
                                <tbody>
                                    <tr>
                                        <td width="50%" style={styles}>Solicitud</td>
                                        <td width="25%" align="center" style={styles}>Fecha</td>
                                        <td width="25%" align="center" style={styles}>Estatus</td>
                                    </tr>
                                    {solicitudes()}
                                </tbody>    
                            </Table>
                        </div>
                    </Col>
                    <Col md ={12}>
                        <div className="custom-alert-warning">Histórico de Mis Carreras</div>
                        <div className="custom-mt-10" style={{marginBottom: 20}}>
                            {this.carreras()}
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    ayuda = () => {
        return(
            <Row align="justify">
                <Col md={12}>
                    <strong style={{color:"#1f2f6e"}}>Paso 1</strong>
                </Col>
                <Col md={12}>
                    Selecciona la carrera. Es <strong>IMPORTANTE</strong> que la carrera seleccionada corresponda a una que hayas cursado.
                </Col>

                <Col md={12} className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 2</strong>
                </Col>
                <Col md={12}>
                    Presiona el botón Solicitar 
                </Col>
                <Col md={12}>
                    <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-file"></i> Notas Certificadas</button> o <button className="btn btn-warning btn-xs" style={{borderWidth: 1}}><i className="fa fa-file-o"></i> Notas Simples</button> según sea tu caso para generar una solicitud. (Solo puedes tener una solicitud abierta)
                </Col>
                <Col md={12} className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 3</strong>
                </Col>
                <Col md={12}>
                    Espera que el Status de tu solicitud cambie a <strong>APROBADA</strong> para poder culminar la solicitud
                </Col>
            </Row>
        )
    }

    render() { 
        return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col md={8}>
                            <Row>
                                <Col md={12}>{this.contenido()}</Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <div style={{borderRadius: "4px 4px",}}>
                                <CustomCard
                                    styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                    title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                    category={<span style={{color: "#fff"}}>Notas Certificadas</span>}
                                    color="#a80012"
                                    content={this.ayuda()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                {this.showModal()}
                {this.showModalS()}
            </React.Fragment>
        );
    }
}
 
export default NotasCertificadas;


// WEBPACK FOOTER //
// ./src/views/EstConsultas/NotasCertificadas.jsx